import {AppState, Linking, View, Dimensions, Platform, TouchableOpacity, Text} from "react-native";
import React, {useEffect, useState} from "react";
import {BarCodeScanner} from "expo-barcode-scanner";
import Button from "./Button";
import {CameraType} from "expo-camera";
import {useDeviceOrientation} from '@react-native-community/hooks';
import {RC, RH, RW} from "../styles/defaultStyles";
import {runOnJS} from "react-native-reanimated";
import {STORAGE} from "../services/storage";
import {responsiveFontSize} from "react-native-responsive-dimensions";
import { CameraView, useCameraPermissions } from 'expo-camera/next';

import {actuatedWithoutScale} from "../services/helpers/stylingHelpers";

const Scanner = ({onScanned, close, embed = false}) => {
    const { height, width } = Dimensions.get('window');
    const [hasCameraPermission, setCameraPermissions] = useState(null)
    const [facing, setFacing] = useState(CameraType.front)
    const [styles, setStyles] = useState(getStyles())
    const orientation = useDeviceOrientation()

    useEffect( () => {
        setStyles(getStyles(!!orientation.portrait))
    }, [orientation])

    useEffect(() => {
        const appStateSubscription = AppState.addEventListener('change', _handleAppStateChange);

        return function cleanup() {
            appStateSubscription.remove();
        };
    }, [])

    useEffect(() => {
        (async () => {
            await _checkPermission()
        })()
    }, [])

    const _handleAppStateChange = async (nextAppState) => {
        const previousState = await STORAGE.get('appState');
        const recheckPermissions = await STORAGE.get('recheckPermissions');

        if (previousState && previousState.match(/inactive|background/) && nextAppState === 'active') {
            if (recheckPermissions) {
                await STORAGE.set('recheckPermissions', 'false')
                await _checkPermission()
            }
        }

        await STORAGE.set('appState', nextAppState)
    }

    const _checkPermission = async () => {
        const { status } = await BarCodeScanner.requestPermissionsAsync()

        setCameraPermissions(status === 'granted')
    }

    const _openSettings = async () => {
        await STORAGE.set('recheckPermissions', 'true')
        await Linking.openSettings()
    }

    function toggleCameraFacing() {
        setFacing(facing === CameraType.back ? CameraType.front : CameraType.back);
    }

    return(
        <View style={[styles.notFullScreen, !embed && styles.fullScreen]}>
            {
                hasCameraPermission ?
                    <View>
                        <CameraView onBarcodeScanned={onScanned} style={[styles.scanner]} type={facing} />
                        <Button onPress={toggleCameraFacing} text={"ROTATE"} additionalStyle={{opacity: hasCameraPermission === null ? 0 : 1}} />
                    </View>
                    :
                    <Button onPress={_openSettings} text={translate("No camera permission granted")} subtext={translate("Tap to go settings")} additionalStyle={{opacity: hasCameraPermission === null ? 0 : 1, paddingLeft: actuatedWithoutScale(30), paddingRight: actuatedWithoutScale(30)}} additionalTextStyle={{fontSize: actuatedWithoutScale(25), paddingBottom: actuatedWithoutScale(10)}} />
            }
            <View style={styles.buttonContainer}>
                {!embed && <Button onPress={close} text={translate("Close").toUpperCase()} additionalStyle={{opacity: hasCameraPermission === null ? 0 : 1}} />}
            </View>
        </View>
    )
}

const getStyles = (portrait = true) => {
    return {
        notFullScreen: {
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: "rgba(0,0,0,0.75)"
        },
        fullScreen: {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            flex: 1,
        },
        container: {
        },
        scanner: {
            height: RC(portrait).maxWidth() / (portrait ? 1.5 : 2.5),
            width: RC(portrait).maxWidth() / (portrait ? 1.5 : 2.5),
            justifyContent: 'center',
        },
        buttonContainer: {
            bottom: RH(10),
            width: RW(25)
        }
    }
};

export default Scanner